export const WHAT_THE_PRICE = 'Сколько стоит ремонт ванной комнаты или туалета?';
export const HOW_LONG = 'Какой срок выполнения работ?';
export const ALWAYS_BEING = 'Надо\u00A0ли мне постоянно присутствовать при ремонте?';
export const MORE_BUYING = 'Что делать, если во время ремонта необходимо докупить товары?';
export const MASTER_EXPERIENCE = 'А мастер опытный?';
